import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiliaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 362,
	viewBox: "0 0 903 362",
	width: 903,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("style", { children: "\n    .primary {\n      fill: #004d99;\n    }\n\n    .secondary {\n      fill: #2e8ae6;\n    }\n\n    body.chakra-ui-dark .primary {\n      fill: #ffffff;\n    }\n\n    body.chakra-ui-dark .secondary {\n      fill: #E2E8F0;\n    }\n  " }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m279 68h-100v286h-79v-286h-99v-64h278z",
			className: "primary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m392 357h-77v-252h77z",
			className: "primary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m519 357h-77v-353h77z",
			className: "primary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m643 357h-77v-252h77z",
			className: "primary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m902 355h-73v-36h-1c-16.797 27.978-42.067 42-75 42-24.304 0-43.068-7.258-57-21s-20.987-32.105-21-55c0-48.461 28.443-76.506 86-84l68-8c0-27.311-14.326-41-44-41-29.834 0-58.065 8.274-85 26v-58c10.759-5.522 25.326-10.763 44-15s35.679-6.0133 51-6c71.416 0 107 35.93 107 107zm-73-102v-16l-45 5c-25.105 3.257-38 14.649-38 34 0 8.786 2.889 16.398 9 22s14.561 7.987 25 8c14.52 0 26.877-5.008 36-15s12.993-22.692 13-38z",
			className: "primary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m354 83c22.92 0 41-18.3563 41-41s-18.08-41-41-41-42 18.3563-42 41 19.08 41 42 41z",
			className: "secondary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m607 83c22.92 0 41-18.3563 41-41s-18.08-41-41-41-42 18.3563-42 41 19.08 41 42 41z",
			className: "secondary"
		})
	] })]
});
export default SvgTiliaLogo;
